/**
 * Social Proof Popup - показывает рандомные уведомления о покупках
 */

class SocialProofPopup {
  constructor() {
    console.log('🎉 Social Proof Popup: Initializing...');

    this.popup = document.getElementById('social-proof-popup');
    if (!this.popup) {
      console.error('❌ Social Proof Popup: Element #social-proof-popup not found!');
      return;
    }
    console.log('✅ Social Proof Popup: Element found', this.popup);

    this.customerElement = this.popup.querySelector('.social-proof-popup__customer');
    this.productElement = this.popup.querySelector('.social-proof-popup__product');
    this.timeElement = this.popup.querySelector('.social-proof-popup__time');
    this.closeButton = this.popup.querySelector('.social-proof-popup__close');

    this.isVisible = false;
    this.displayDuration = 8000; // Показывать 8 секунд
    this.minInterval = 25000; // Минимум 25 секунд между показами
    this.maxInterval = 45000; // Максимум 45 секунд между показами
    this.currentTimeout = null;
    this.hideTimeout = null;

    this.init();
  }

  init() {
    console.log('🔧 Social Proof Popup: Setting up event listeners...');

    // Обработчик закрытия
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.hide());
    }

    // Закрыть при клике вне попапа
    this.popup.addEventListener('click', (e) => {
      if (e.target === this.popup) {
        this.hide();
      }
    });

    // Запустить первое уведомление через 15-25 секунд после загрузки
    const initialDelay = Math.random() * 10000 + 15000;
    console.log(`⏰ Social Proof Popup: First notification will show in ${Math.round(initialDelay/1000)} seconds`);
    setTimeout(() => {
      this.show(); // Показать сразу первое уведомление
    }, initialDelay);

    // Пауза при наведении
    this.popup.addEventListener('mouseenter', () => {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
      }
    });

    this.popup.addEventListener('mouseleave', () => {
      if (this.isVisible) {
        this.hideTimeout = setTimeout(() => this.hide(), 2000);
      }
    });
  }

  show() {
    if (this.isVisible) {
      console.log('⚠️ Social Proof Popup: Already visible, skipping...');
      return;
    }

    console.log('🎬 Social Proof Popup: Showing notification...');

    // Получить рандомные данные
    const data = this.getRandomData();
    console.log('📦 Social Proof Popup: Data:', data);

    // Заполнить содержимое
    this.customerElement.textContent = `${data.name} aus ${data.city}`;
    this.productElement.textContent = `hat "${data.product.name}" gekauft`;
    this.timeElement.textContent = data.time;

    // Показать попап
    this.popup.classList.add('show');
    this.isVisible = true;
    console.log('✅ Social Proof Popup: Notification visible!');

    // Скрыть через displayDuration
    this.hideTimeout = setTimeout(() => {
      this.hide();
    }, this.displayDuration);
  }

  hide() {
    if (!this.isVisible) return;

    this.popup.classList.remove('show');
    this.isVisible = false;

    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }

    // Запланировать следующее уведомление
    this.scheduleNext();
  }

  scheduleNext() {
    if (this.currentTimeout) {
      clearTimeout(this.currentTimeout);
    }

    // Рандомная задержка между minInterval и maxInterval
    const delay = Math.random() * (this.maxInterval - this.minInterval) + this.minInterval;

    this.currentTimeout = setTimeout(() => {
      this.show();
    }, delay);
  }

  getRandomData() {
    const data = window.socialProofData;
    if (!data) {
      console.error('Social proof data not found');
      return {
        name: 'Anna',
        city: 'Berlin',
        product: { name: 'Schmuck' },
        time: 'gerade eben'
      };
    }

    return {
      name: this.getRandomItem(data.names),
      city: this.getRandomItem(data.cities),
      product: this.getRandomItem(data.products),
      time: this.getRandomItem(data.times)
    };
  }

  getRandomItem(array) {
    return array[Math.floor(Math.random() * array.length)];
  }

  destroy() {
    if (this.currentTimeout) {
      clearTimeout(this.currentTimeout);
    }
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
  }
}

// Инициализация при загрузке DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.socialProofPopup = new SocialProofPopup();
  });
} else {
  window.socialProofPopup = new SocialProofPopup();
}
